module.exports = __webpack_public_path__ + "img/card.525e2453.png";